import { httpClient } from "@coworker/http-client";
import { NewTeamDataType } from "../types/TeamMutationTypes";

async function updateTeam(newTeamData: NewTeamDataType) {
  const result = await httpClient.core.put(`/teams/${newTeamData.team_id}`, {
    body: newTeamData,
  });

  return result;
}

export default updateTeam;
